import { render, staticRenderFns } from "./EditWorkPage.vue?vue&type=template&id=9a755dda&"
import script from "./EditWorkPage.vue?vue&type=script&lang=js&"
export * from "./EditWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports